import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  FormControl,
  Validators,
} from '@angular/forms';
import { IRealizarPqrsForm } from '../../interfaces/consulta-externa-pqrs.interface';

@Injectable({ providedIn: 'root' })
export class FormBuilderService {
  private fb = inject(FormBuilder);

  private form!: FormGroup<IRealizarPqrsForm>;

  buildForm(): FormGroup<IRealizarPqrsForm> {
    this.form = this.fb.group<IRealizarPqrsForm>({
      CodTipoPqr: this.createControl<number | null>(null, Validators.required),
      Asunto: this.createControl<string | null>(null, Validators.required),
      Descripcion: this.createControl<string | null>(null, Validators.required),
      fileBase64DocPqr: this.createControl<string | null>(null),

      idPqrs: this.createControl<number | null>(null),
      codPeticionario: this.createControl<number | null>(null),
      NumeroDocumento: this.createControl<string | null>(null),
      codUserUpdate: this.createControl<string | null>(null),
      CodGlobal: this.createControl<string | null>(null),
      AutorizoDatos: this.createControl<boolean | null>(null),
    });
    return this.form;
  }

  private createControl<T>(
    value: T | { value: T | null; disabled: boolean } | null,
    validators?: ValidatorFn | ValidatorFn[] | null
  ): FormControl<T | null> {
    return this.fb.control(value, validators);
  }

  getErrorMessage(field: string): string {
    const control = this.form.get(field);
    if (!control?.errors) return '';
    const errors = control.errors;

    if (errors['required'])
      return `${this.getFieldDisplayName(field)} es obligatorio`;
    if (errors['minlength'])
      return `${this.getFieldDisplayName(field)} debe tener al menos ${
        errors['minlength'].requiredLength
      } caracteres`;
    if (errors['maxlength'])
      return `${this.getFieldDisplayName(field)} no puede tener más de ${
        errors['maxlength'].requiredLength
      } caracteres`;
    if (errors['min'])
      return `${this.getFieldDisplayName(field)} debe ser mayor a ${
        errors['min'].min
      }`;

    return 'Campo inválido';
  }
  private getFieldDisplayName(fieldName: string): string {
    const displayNames: Record<string, string> = {
      Id: 'Id',
      nombre: 'Nombre',
      estado: 'Estado',
      observacion: 'Observación',
    };
    return displayNames[fieldName] || fieldName;
  }
}
